var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-2",
    d: "M4 0.5H16C17.3789 0.5 18.5 1.62114 18.5 3V23C18.5 23.2739 18.2739 23.5 18 23.5H2C1.72614 23.5 1.5 23.2739 1.5 23V3C1.5 1.62114 2.62114 0.5 4 0.5Z",
    fill: "#EAEEF2",
    stroke: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11.75 16.625H5.25C4.835 16.625 4.5 16.29 4.5 15.875C4.5 15.46 4.835 15.125 5.25 15.125H11.75C12.165 15.125 12.5 15.46 12.5 15.875C12.5 16.29 12.165 16.625 11.75 16.625Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M14.75 19.875H5.25C4.835 19.875 4.5 19.54 4.5 19.125C4.5 18.71 4.835 18.375 5.25 18.375H14.75C15.165 18.375 15.5 18.71 15.5 19.125C15.5 19.54 15.165 19.875 14.75 19.875Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarBottom);
export default __webpack_public_path__ + "static/media/bar-bottom.5b61952058c07af5c6a9e0b4a3e39e2c.svg";
export { ForwardRef as ReactComponent };